import * as React from "react";
import { cn, DataObserveKey, FocusableComponent, VisualComponent } from "@siteimprove/fancylib";
import * as scss from "./illustration.scss";

export type IllustrationProps = {
	/** The illustration image source (base64, SVG, URL, or file path) */
	src: string;
	/** Controls the illustration size - defaults to medium */
	size?: "small" | "medium" | "large" | { width: string | number; height: string | number };
	/** Meaningful alt text that explains the illustration */
	alt?: string;
	/** If true, the illustration doesn’t need an alt text */
	decorative?: boolean;
} & DataObserveKey &
	VisualComponent &
	FocusableComponent;

export function Illustration(props: IllustrationProps): JSX.Element {
	const { alt, className, decorative, src: href, size = "medium", ...rest } = props;

	if (!decorative && !alt)
		throw new Error("Alt-text is required for non-decorative illustrations.");

	return (
		<img
			alt={decorative ? "" : alt}
			className={cn(typeof size === "string" && scss[size], className)}
			data-component="illustration"
			data-observe-key={props["data-observe-key"]}
			src={props.src}
			{...(typeof size === "object" ? size : undefined)}
			{...rest}
		/>
	);
}
